'use client';

import { clientLogProtobuf } from '@weberus/client-tracker/utils';
import { useEffect } from 'react';
import { yaNative } from '@weberus/ui/utils/ya-native';
import { useVisibilityChange } from '@/app/_shared/hooks/use-visibility-change';
import { ProductListPageLog } from '@/app/_shared/protobuf-log/clientlogs/product-list-web-txtpb';

export const ClientLogger = (logMeta: Record<string, unknown>) => {
  const sendPageViewLog = async () => {
    clientLogProtobuf?.(ProductListPageLog.Search.view, logMeta)();
  };

  useVisibilityChange({
    isActive: yaNative.isEnabled,
    onVisible: () => sendPageViewLog(),
  });

  useEffect(() => {
    sendPageViewLog();
  }, []);

  return null;
};
